import { render, staticRenderFns } from "./CoachList.vue?vue&type=template&id=45e83bc5&scoped=true&"
import script from "./CoachList.vue?vue&type=script&lang=js&"
export * from "./CoachList.vue?vue&type=script&lang=js&"
import style0 from "./CoachList.vue?vue&type=style&index=0&id=45e83bc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e83bc5",
  null
  
)

export default component.exports